function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck
import { Dimensions } from 'react-native';
export class Point {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }

  static zero() {
    return new Point(0, 0);
  }

  static outscreen() {
    return new Point(-999, -999);
  }

  equals(other) {
    if (!other) {
      return false;
    }

    return this.x === other.x && this.y === other.y;
  }

}
export class Size {
  constructor(width, height) {
    this.width = width;
    this.height = height;
  }

  static zero() {
    return new Size(0, 0);
  }

  equals(other) {
    if (!other) {
      return false;
    }

    return this.width === other.width && this.height === other.height;
  }

}
export class Frame {
  constructor(x, y, width, height) {
    _defineProperty(this, "origin", void 0);

    _defineProperty(this, "size", void 0);

    this.origin = new Point(x, y);
    this.size = new Size(width, height);
  }

  static zero() {
    return new Frame(0, 0, 0, 0);
  }

  static window() {
    const window = Dimensions.get('window');
    return new Frame(0, 0, window.width, window.height);
  }

  static outscreen() {
    const point = Point.outscreen();
    return new Frame(point.x, point.y, 0, 0);
  }

  equals(other) {
    if (!other) {
      return false;
    }

    return this.origin.equals(other.origin) && this.size.equals(other.size);
  }
  /**
   * Creates new frame aligned to left of other
   */


  leftOf(other) {
    return new Frame(other.origin.x - this.size.width, this.origin.y, this.size.width, this.size.height);
  }
  /**
   * Creates new frame aligned to top of other
   */


  topOf(other) {
    return new Frame(this.origin.x, other.origin.y - this.size.height, this.size.width, this.size.height);
  }
  /**
   * Creates new frame aligned to right of other
   */


  rightOf(other) {
    return new Frame(other.origin.x + other.size.width, this.origin.y, this.size.width, this.size.height);
  }
  /**
   * Creates new frame aligned to bottom of other
   */


  bottomOf(other) {
    return new Frame(this.origin.x, other.origin.y + other.size.height, this.size.width, this.size.height);
  }
  /**
   * Creates new frame centered horizontally to other
   */


  centerHorizontalOf(other) {
    return new Frame(other.origin.x + (other.size.width - this.size.width) / 2, this.origin.y, this.size.width, this.size.height);
  }
  /**
   * Creates new frame centered vertically to other
   */


  centerVerticalOf(other) {
    return new Frame(this.origin.x, other.origin.y + (other.size.height - this.size.height) / 2, this.size.width, this.size.height);
  }

  centerOf(other) {
    return new Frame(other.origin.x + (other.size.width - this.size.width) / 2, other.origin.y + (other.size.height - this.size.height) / 2, this.size.width, this.size.height);
  }

}